import { Drawer, SimpleToolbar, Loader, Toast } from "../../../components";
import { Grid, Container, makeStyles } from "@material-ui/core";
import { useDrawer } from "../../../hooks";
import { AuthContext } from "../../../context";
import { useContext, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { laboratoryServices } from "../../../services";
import RefillCategoryForm from "../../../components/refill/category-form";

const getErrorMessage = (message) => {
  if (message.includes("invalid"))
    return "Algunos datos son invalidos, por favor revise.";
  if (message.includes("Laboratory already has a basal category."))
    return "El laboratorio ya tiene una categoria basal.";
  if (message.includes("already has") || message.includes("already have"))
    return "La categoria ya se encuentra registrada.";
  else return "No se ha podido crear la categoria.";
};

export default function CreateRefillCategoryScreen() {
  const { authState, signOut } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ open: false, message: "" });
  const classes = useStyles();
  const history = useHistory();

  const handleOnSubmit = async (data, type) => {
    // console.log(data, type);
    let submit = null;
    if (type === "refill") submit = handleOnSubmitRefillCategory(data);
    else submit = handleOnSubmitBasalCategory(data);
    try {
      setLoading(true);
      const { status, response } = await submit;
      if (status === 200) {
        setToast({ open: true, message: "Categoria agregada exitosamente" });
        setTimeout(() => {
          history.replace("/refill");
        }, 500);
      } else {
        const errorMessage =
          type === "basal" ? response.error.message : response.message;
        setToast({ open: true, message: getErrorMessage(errorMessage) });
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleOnSubmitRefillCategory = async (data) =>
    await laboratoryServices.addProductsRefillCategories({
      token: authState.token,
      laboratoryId: authState.user.laboratory._id,
      productsRefillCategoryData: data,
    });
  const handleOnSubmitBasalCategory = async (data) =>
    await laboratoryServices.addBasalCategory({
      token: authState.token,
      laboratoryId: authState.user.laboratory._id,
      basalCategory: data,
    });
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        {loading && <Loader loading={true} />}
        <Toast
          open={toast.open}
          message={toast.message}
          close={() => setToast({ open: false, message: "" })}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={authState.user.laboratory}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              noSearchBar
            />
          </Container>

          <Container
            maxWidth={"md"}
            component={"main"}
            className={classes.container_main}
          >
            <RefillCategoryForm onSubmit={handleOnSubmit} />
          </Container>
        </Grid>
      </Grid>
    </>
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    flex: 1,
    minHeight: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  container_main: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(2),
    height: "100%",
  },
}));
